var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"range px-360",style:({background:'url('+ _vm.bg + ') no-repeat center',backgroundSize:'100% 100%'})},[_c('div',{staticClass:"tips hidden-xs-only",style:({background:'url('+ _vm.tipBg + ') no-repeat center',backgroundSize:'100% 100%'})},[_c('p',[_vm._v(_vm._s(_vm.info[0])),_c('br'),_vm._v(_vm._s(_vm.info[1]))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }